/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignedCompanyRepresentation
 */
export interface AssignedCompanyRepresentation {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof AssignedCompanyRepresentation
     */
    documentKeysMap: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the AssignedCompanyRepresentation interface.
 */
export function instanceOfAssignedCompanyRepresentation(value: object): value is AssignedCompanyRepresentation {
    if (!('documentKeysMap' in value) || value['documentKeysMap'] === undefined) return false;
    return true;
}

export function AssignedCompanyRepresentationFromJSON(json: any): AssignedCompanyRepresentation {
    return AssignedCompanyRepresentationFromJSONTyped(json, false);
}

export function AssignedCompanyRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedCompanyRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'documentKeysMap': json['documentKeysMap'],
    };
}

export function AssignedCompanyRepresentationToJSON(json: any): AssignedCompanyRepresentation {
    return AssignedCompanyRepresentationToJSONTyped(json, false);
}

export function AssignedCompanyRepresentationToJSONTyped(value?: AssignedCompanyRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentKeysMap': value['documentKeysMap'],
    };
}

